import { greeting } from "utils/helpers";

export const signupForm = {
  form_title: "Create an account",
  form_subtitle: "Join the ",
  button_label: "Sign Up",
  button_styles: "block btn-blue",
  fields: [
    {
      key: "email",
      label: "Email",
      name: "email",
      type: "email",
    },
    {
      key: "names",
      label: "Names (not intermediary name)",
      name: "names",
      type: "text",
    },

    {
      key: "category",
      label: "Category",
      name: "category",
      type: "select",
      options: [
        {key:"", label:"--Select--", value:""},
        { key: "agent", label: "Agent", value: "AGENT" },
        { key: "broker", label: "Broker", value: "BROKER" },
        { key: "bank_assurance", label: "Bancassurance", value: "BANCASSURANCE"},
      ],
    },
    {
      key: "ira_code",
      label: "IRA Code",
      name: "ira_code",
      type: "MaskedInput",
    },
  ],
};
